<template>
  <article
    class="catalog-artist"
    :data-tone="artistTone(artist)"
  >
    <button
      class="catalog-portrait"
      :aria-label="$t('catalog.open-artist', { name: artist.name })"
      @click="$emit('open', artist)"
    >
      <img
        v-if="photo && !imageFailed"
        :src="photo"
        :alt="artist.name"
        loading="lazy"
        @error="imageFailed = true"
      >
      <span
        v-else
        class="catalog-monogram"
        aria-hidden="true"
      >{{ artistInitials(artist.name) }}<GrowthIcon name="spark" /></span>
      <span
        v-if="following"
        class="catalog-followed"
      ><GrowthIcon name="check" />{{ $t('feed.following-artist') }}</span>
      <span
        class="catalog-open-icon"
        aria-hidden="true"
      ><GrowthIcon name="arrow" /></span>
    </button>
    <div class="catalog-artist-info">
      <div class="catalog-artist-tags">
        <span>{{ artist.main_genre || $t('discovery.independent') }}</span><span
          v-if="artist.pro || artist.user?.subscription"
          class="catalog-pro"
        >{{ $t('growthHub.access.pro') }}</span>
      </div>
      <h3>
        <button @click="$emit('open', artist)">
          {{ artist.name }}
        </button>
      </h3>
      <CountryLabel
        v-if="artist.user?.country || artist.country"
        :value="artist.user?.country || artist.country"
      />
      <p
        v-if="artist.style"
        class="catalog-artist-style"
      >
        {{ artist.style }}
      </p>
      <div class="catalog-artist-footer">
        <span v-if="followerCount !== null"><strong>{{ n(followerCount) }}</strong> {{ $t('general.followers') }}</span><button
          class="product-text-button"
          @click="$emit('open', artist)"
        >
          {{ $t('catalog.meet-artist') }}<GrowthIcon name="arrow" />
        </button>
      </div>
    </div>
  </article>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import GrowthIcon from '@/components/growth/GrowthIcon.vue';
import CountryLabel from '@/components/common/CountryLabel.vue';
import { artistInitials, artistTone } from '@/utils/artistCatalog';
const props = defineProps({ artist: { type: Object, required: true }, following: Boolean });
defineEmits(['open']);
const { n } = useI18n();
const imageFailed = ref(false);
const photo = computed(() => props.artist.cover_image || props.artist.cover_image_small);
const followerCount = computed(() => props.artist.followers !== undefined && props.artist.followers !== null && Number.isFinite(Number(props.artist.followers)) ? Math.max(0, Number(props.artist.followers)) : null);
watch(photo, () => { imageFailed.value = false; });
</script>
